var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"lyrics-container"},_vm._l((_vm.lyrics),function(value,key){return _c('div',{key:key,staticClass:"lyrics-line",class:{ 'lyrics-active': _vm.activeLine == key }},[_vm._v(" "+_vm._s(value)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }